export const SEARCH_SYSTEM_NAME = 'search_system_name',
						 RECEIVE_SYSTEM_INFO = 'receive_system_info',
						 RECEIVE_SYSTEMS_BY_NAME = 'receive_systems_by_name',
						 TOGGLE_SIDEBAR = 'toggle_sidebar',
						 SELECT_SYSTEM = 'select_system',
						 FETCH_SYSTEM_INFO = 'fetch_system_info',
						 SET_SYSTEM_DISTANCE = 'set_system_distance',
						 TOGGLE_SYSTEM_LABELS = 'toggle_system_labels',
						 TOGGLE_CURSOR = 'toggle_cursor',
						 TOGGLE_VIEW_MODE = 'toggle_view_mode',
						 UPDATE_HUD = 'update_hud',
						 TEST = 'test';


// WEBPACK FOOTER //
// ./src/actiontypes/index.js